import { Trash2 } from "lucide-react";
import { useState } from "react";

import { useCart } from "../context/CartContext";
import { formatCurrency } from "../utils/format";

export function CartItem({ item }) {
  const { loading, removeItem, updateQuantity } = useCart();
  const [imageError, setImageError] = useState(false);

  async function handleRemove() {
    try {
      await removeItem(item);
    } catch (error) {
      // CartContext already captures the error for UI display.
    }
  }

  async function handleQuantityChange(nextQuantity) {
    try {
      await updateQuantity(item, nextQuantity);
    } catch (error) {
      // CartContext already captures the error for UI display.
    }
  }

  return (
    <div className="rounded-[1.5rem] border border-border bg-background/75 p-4">
      <div className="flex gap-4">
        <div className="h-20 w-20 overflow-hidden rounded-2xl bg-secondary">
          {item.imageUrl && !imageError ? (
            <img
              alt={item.name}
              className="h-full w-full object-cover"
              loading="lazy"
              onError={() => setImageError(true)}
              src={item.imageUrl}
            />
          ) : (
            <div className="flex h-full items-center justify-center px-2 text-center text-xs text-muted-foreground">
              No Image Available
            </div>
          )}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-3">
            <div>
              <h3 className="font-semibold">{item.name}</h3>
              <p className="mt-1 text-sm text-muted-foreground">
                {formatCurrency(item.price)} {item.uomDesc ? `/ ${item.uomDesc}` : "each"}
              </p>
              {item.uomDesc ? (
                <p className="mt-1 text-xs text-muted-foreground">
                  UOM: {item.uomDesc}
                  {item.unitPerCarton ? ` • ${item.unitPerCarton} per carton` : ""}
                </p>
              ) : null}
            </div>
            <button
              className="rounded-full p-2 text-muted-foreground transition hover:bg-accent"
              disabled={loading}
              onClick={handleRemove}
              type="button"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>

          <div className="mt-4 flex items-center justify-between gap-4">
            <div className="flex items-center gap-2 rounded-full border border-border bg-card px-2 py-1">
              <button
                className="rounded-full px-2 py-1 text-sm font-semibold transition hover:bg-accent"
                disabled={loading}
                onClick={() => handleQuantityChange(item.qty - 1)}
                type="button"
              >
                -
              </button>
              <span className="min-w-8 text-center text-sm font-semibold">{item.qty}</span>
              <button
                className="rounded-full px-2 py-1 text-sm font-semibold transition hover:bg-accent"
                disabled={loading}
                onClick={() => handleQuantityChange(item.qty + 1)}
                type="button"
              >
                +
              </button>
            </div>
            <p className="font-semibold">{formatCurrency(item.total)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
